import { SessionProvider } from "@/providers/SessionProvider";
import { FavoritesProvider } from "@/contexts/FavoritesContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import AppRouter from "@/router";

export default function App() {
  return (
    <SessionProvider>
      <ThemeProvider>
        <FavoritesProvider>
          <div className="h-full font-sans">
            <AppRouter />
          </div>
        </FavoritesProvider>
      </ThemeProvider>
    </SessionProvider>
  );
}
